<template>
  <v-dialog v-model="showModal" persistent max-width="500">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>
          <v-icon>info</v-icon>
            Sure you want to activate this round?
          </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="$emit('close-modal-activate-round')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <span class="subheading">Once the round is activated, only the following items can be modified:</span>
        
        <v-list prepend-icon="directions_run">
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>date_range</v-icon>
              Start Date / End date
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>perm_contact_calendar</v-icon>
              Contacts by Excel
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>mark_email_read</v-icon>
              Template Sender / Reminder
            </v-list-tile-title>
          </v-list-tile>
          <!--
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>question_answer</v-icon>
              Questions Order
            </v-list-tile-title>
          </v-list-tile>
          <v-list-tile>
            <v-list-tile-title>
              <v-icon>account_tree</v-icon>
              Question Flow <span disabled>(Only Advanced Round)</span>
            </v-list-tile-title>
          </v-list-tile>
          -->
          
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" flat @click="$emit('close-modal-activate-round')">No</v-btn>
        <v-btn color="green darken-1" flat @click="$emit('activate-round'); $emit('close-modal-activate-round')">Yes</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
  },
};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/client/rounds/modals/ActivateRound.vue